import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { URL_IMAGES_I } from 'constants/UrlConstants';

const Iframe = styled.iframe`
    position: relative;
    height: 250px;
    width: 100%;
    border-style: none;
    display: block;
    overflow: hidden;
`;

const FtLogo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }

    img {
        margin-bottom: 24px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    @media screen and (min-width: 1352px) {
        flex-direction: row;
        justify-content: center;

        img {
            margin-bottom: 0;
            margin-right: 24px;

            &:last-child {
                margin-right: 0;
            }
        }
    }
`;

const Trustpilot = (props) => {
    const data = props.data;
    if (__isDev__) {
        return false;
    } else {
        return (
            <section className="section-trustpilot js_trustpilot_initialized" id="trustpilot">
                <div className="box-1280">
                    <div className="inner-content">
                        <div className="lead-text max-620">
                            <h2 className="title1">{data.header.title}</h2>
                            <p className="maincopy color-medium-gray">{data.header.text}</p>
                        </div>
                        <div
                            data-schema-type="Organization"
                            data-stars="5"
                            data-theme="light"
                            data-style-width="100%"
                            data-style-height="250px"
                            data-businessunit-id="59295ddd0000ff0005a34b26"
                            data-template-id="53aa8912dec7e10d38f59f36"
                            data-tags={data.tag}
                            data-locale={data.lang}
                            className="trustpilot-widget"
                            style={{ position: 'relative' }}
                        >
                            <Iframe
                                frameBorder="0"
                                scrolling="no"
                                title="Customer reviews powered by Trustpilot"
                                loading="auto"
                                src="https://widget.trustpilot.com/trustboxes/53aa8912dec7e10d38f59f36/index.html?businessunitId=59295ddd0000ff0005a34b26&amp;templateId=53aa8912dec7e10d38f59f36#schemaType=Organization&amp;stars=5&amp;theme=light&amp;styleWidth=100%25&amp;styleHeight=250px&amp;tags=ru&amp;locale=ru"
                            />
                        </div>
                        <FtLogo>
                            <img src={`${URL_IMAGES_I}/ft-logo.svg`} alt="FT logo" width="274" height="72" />
                            <img src={`${URL_IMAGES_I}/ft-logo-2024.svg`} alt="FT logo 2024" width="274" height="72" />
                        </FtLogo>
                        <FtLogo>
                            <img src={`${URL_IMAGES_I}/lazard-logo.svg`} alt="Lazard logo" width="117" height="90" />
                        </FtLogo>
                    </div>
                </div>
            </section>
        );
    }
};

Trustpilot.propTypes = {
    data: PropTypes.shape({
        header: PropTypes.exact({
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        }),
        tag: PropTypes.string.isRequired,
        lang: PropTypes.string.isRequired,
    }),
};

export default Trustpilot;
